import { components, MenuProps } from 'react-select';

import { SelectOptionType } from '../../../..';

import css from './index.module.css';

export const BlockchainMenu = (props: MenuProps<SelectOptionType>) => (
  <components.Menu className={css.menu} {...props} />
);
